// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__14dQd","col":"styles_col__2rfbb"};